import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import CKEditor from "ckeditor4-vue";

Vue.config.productionTip = false;
Vue.use(CKEditor);

new Vue({
  router,
  store,
  vuetify,
  beforeCreate() {
    this.$store.dispatch("register/sessionLogin");
  },
  render: (h) => h(App),
}).$mount("#app");
